import { CalendarX, UserX } from 'lucide-react';

type EmptyHintVariant = 'slots' | 'consultants';

interface EmptyHintProps {
  variant: EmptyHintVariant;
  title?: string;
  hint?: string;
}

const DEFAULTS: Record<EmptyHintVariant, { title: string; hint: string }> = {
  slots: {
    title: 'Nessuno slot disponibile per queste scelte',
    hint: 'Prova a selezionare un altro giorno, una sede diversa o, se possibile, un altro consulente.',
  },
  consultants: {
    title: 'Nessun consulente disponibile per queste scelte',
    hint: 'Prova a cambiare sede, servizio o giorno: con criteri diversi potrebbero esserci consulenti liberi.',
  },
};

export default function EmptyHint({ variant, title, hint }: EmptyHintProps) {
  const fallback = DEFAULTS[variant];
  const Icon = variant === 'slots' ? CalendarX : UserX;
  return (
    <div className="aw-empty-hint" role="status" aria-live="polite">
      <Icon className="aw-empty-hint-icon" size={28} aria-hidden="true" />
      <p className="aw-empty-hint-title">{title ?? fallback.title}</p>
      <p className="aw-empty-hint-text">{hint ?? fallback.hint}</p>
    </div>
  );
}
